import { useQueryClient } from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";

import { useContactsFlowStrategy } from "app/pages/sales-intelligence/sub-modules/contacts-search/context/ContactsFlowContext";

import { contactReportedAction, contactIssueModalToggledAction } from "../../store/action-creators";
import { selectContactIssueModalPayload } from "../../store/selectors";
import type { ContactSearchEntry, ContactsSearchResults } from "../../types/common";

import ContactIssueModal from "./ContactIssueModal";

const ContactIssueModalContainer = () => {
    const dispatch = useDispatch();
    const queryClient = useQueryClient();
    const strategy = useContactsFlowStrategy();

    const modalPayload = useSelector(selectContactIssueModalPayload);

    const handleClose = () => {
        dispatch(contactIssueModalToggledAction(null));
    };

    const handleSubmit = () => {
        if (!modalPayload) {
            return;
        }

        const { contact } = modalPayload;

        dispatch(contactReportedAction(contact.id));

        const queryKey = strategy.getRevealCacheKey();

        queryClient.setQueryData(queryKey, (oldData: ContactsSearchResults | undefined) => {
            if (!oldData) {
                return oldData;
            }

            return {
                ...oldData,
                rows: oldData.rows.map((row: ContactSearchEntry) =>
                    row.id === contact.id ? { ...row, hasIssues: true } : row,
                ),
            };
        });
    };

    if (!modalPayload) {
        return null;
    }

    return (
        <ContactIssueModal
            isOpen
            contact={modalPayload.contact}
            onClose={handleClose}
            onSubmit={handleSubmit}
        />
    );
};

export default ContactIssueModalContainer;
